import { makeStyles } from "@material-ui/core";

export const useAddTweetModalStyles = makeStyles(() => ({
    content: {
        top: "-20%"
    },
    dialogContent: {
        width: 598,
        minHeight: 288,
        padding: "10px 20px 10px 20px"
    }
}));
